import api from "@helpers/api";
import { VendorCreateType } from "@type/procurements/vendor";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_BASE_URL}${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE}/api/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_VERSION}/${process.env.REACT_APP_EMPLOYEE_PROCUREMENT_SERVICE_TYPE}/vendors`;

export const fetchVendors = async (query: any) => {
  const res = await api.get(apiEndPoint, {
    params: query,
  });

  return res;
};

export const fetchVendorById = async (id: number | string) => {
  const res = await api.get(`${apiEndPoint}/${id}`);

  return res;
};

export const createVendor = async (data: VendorCreateType) => {
  const res = await api.post(apiEndPoint, {
    ...data,
  });

  return res;
};

export const updateVendor = async (id: string | number, data: any) => {
  const res = await api.put(`${apiEndPoint}/${id}`, {
    ...data,
  });

  return res;
};

export const deleteVendor = async (id: string | number) => {
  const res = await api.delete(`${apiEndPoint}/${id}`);

  return res;
};

export const verifyVendor = async (id: string | number, data: any) => {
  const res = await api.put(`${apiEndPoint}/${id}/verification`, data);

  return res;
};

export const fetchBlackLists = async (id: string | number) => {
  const res = await api.get(`${apiEndPoint}/${id}/blacklist-history`);

  return res;
};

export const fetchSingleBlackLists = async (
  id: string | number,
  historyId?: number | null,
) => {
  const res = await api.get(
    `${apiEndPoint}/${id}/blacklist-history/${historyId}`,
  );

  return res;
};

export const createBlackList = async (id: string | number, data: any) => {
  try {
    const resData = await api.post(`${apiEndPoint}/${id}/blacklist-history`, {
      ...data,
    });
    return {
      resData,
      status: "SUCCESS",
    };
  } catch (error) {
    return {
      status: "FAILED",
    };
  }
};

export const updateBlackList = async (
  id: string | number,
  data: VendorCreateType,
  blacklistId: string | number | undefined | null,
) => {
  try {
    const res = await api.put(
      `${apiEndPoint}/${id}/blacklist-history/${blacklistId}`,
      {
        ...data,
      },
    );
    return {
      ...res,
      status: "SUCCESS",
    };
  } catch (err) {
    return {
      status: "FAILED",
    };
  }
};
